import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useDocumentItem = () => {
  const [params] = useSearchParams();
  const initialTab = params.get('initialTab');
  const [activeTab, setActiveTab] = useState(0);
  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    if (initialTab !== undefined) {
      handleTabChange(null, Number(initialTab));
    }
  }, [initialTab]);

  return {
    activeTab,
    handleTabChange,
  };
};
